<template>
  <div class="content display">
    <div class="top">
      <h1>사무비품관리 현황<span class="today">[ {{navigationData.nowYYYY}}.{{navigationData.nowMM}}.{{navigationData.nowDD}} {{navigationData.nowHH}}:{{navigationData.nowMI}}:{{navigationData.nowSS}} ]</span></h1>
    </div>
    <div class="box_gew">
      <main-stock-view></main-stock-view>
      <main-task-view></main-task-view>
    </div>
  </div>
</template>

<script>
import EtnersDateTimeUtil from '@/common/etners.datetime.util'

import MainStockView from './MainStockView'
import MainTaskView from './MainTaskView'
export default {
  components: {
    MainTaskView, MainStockView
  },
  data () {
    const nowDate = new Date()

    let nowYYYY = nowDate.getFullYear()

    let nowMM = EtnersDateTimeUtil.convertTwoDigit(nowDate.getMonth() + 1)
    let nowDD = EtnersDateTimeUtil.convertTwoDigit(nowDate.getDate())

    let nowHH = EtnersDateTimeUtil.convertTwoDigit(nowDate.getHours())
    let nowMI = EtnersDateTimeUtil.convertTwoDigit(nowDate.getMinutes())
    let nowSS = EtnersDateTimeUtil.convertTwoDigit(nowDate.getSeconds())

    return {
      navigationData : {
        nowDate : nowDate, //이 페이지를 열고 있는 시점의 현재 날짜.
        nowYYYY : nowYYYY, //이 페이지를 열고 있는 시점의 현재 연도.
        nowMM : nowMM,  //이 페이지를 열고 있는 시점의 현재 월값.
        nowDD : nowDD,
        nowHH : nowHH,
        nowMI : nowMI,
        nowSS : nowSS,
      },
    }
  },
  mounted(){




    this.$store.dispatch('initGewSearchDataForCodeRequest')

    const vm = this

    vm.refreshDateTime()
  },
  methods: {
    refreshDateTime: function() {
      const vm = this

      const nowDate = new Date()

      let nowYYYY = nowDate.getFullYear()

      let nowMM = EtnersDateTimeUtil.convertTwoDigit(nowDate.getMonth() + 1)
      let nowDD = EtnersDateTimeUtil.convertTwoDigit(nowDate.getDate())

      let nowHH = EtnersDateTimeUtil.convertTwoDigit(nowDate.getHours())
      let nowMI = EtnersDateTimeUtil.convertTwoDigit(nowDate.getMinutes())
      let nowSS = EtnersDateTimeUtil.convertTwoDigit(nowDate.getSeconds())

      vm.navigationData.nowYYYY = nowYYYY
      vm.navigationData.nowMM = nowMM
      vm.navigationData.nowDD = nowDD
      vm.navigationData.nowHH = nowHH
      vm.navigationData.nowMI = nowMI
      vm.navigationData.nowSS = nowSS

      setTimeout(function() {
        vm.refreshDateTime()
      }, 1000)
    },
  }
}
</script>
<style>
  .k-dropdown-wrap>.k-input{
    height:100%
  }
</style>
